import { Result } from "antd";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import Login from "../screens/login/Login";
import Signup from "../screens/Signup/Signup";
import { ProtectedLayout } from "./ProtectedRoutes";
import {
  CleanerLayout,
  CommonLayout,
  ContractorLayout,
  CustomerLayout,
  HomeLayout,
} from "./PublicRoutes";
import ForgetPassword from "../screens/login/ForgetPassword";
import CheckList from "../screens/CheckLists/CheckList/CheckList";
import Profile from "../screens/Profile/Profile";
import ContractorHome from "../screens/ContractorHome/ContractorHome";
import Categories from "../screens/Categories/Categories";
import Location from "../screens/Location/Location";
import EditProfile from "../screens/EditProfile/EditProfile";
import LocationDetail from "../screens/Location/LocationDetail";
import CategoriesDetail from "../screens/Categories/CategoriesDetail";
import Subscription from "../screens/subscription/Subscription";
import AddCard from "../screens/AddCard/AddCard";
import Payments from "../screens/Payment/Payments";
import TermsAndConditions from "../screens/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "../screens/PrivacyPolicy/PrivacyPolicy";
import ContactUs from "../screens/ContactUs/ContactUs";
import Chat from "../screens/Chat/Chat";
import Inbox from "../screens/Chat/Inbox";
import WorkOrders from "../screens/WorkOrderRequest/WorkOrders/WorkOrders";
import ChecklistReport from "../screens/CheckLists/ChecklistReport/ChecklistReport";
import CreateCheckList from "../screens/CheckLists/CreateCheckList/CreateCheckList";
import WeeklyInspectionlist from "../screens/WeeklyInspection/WeeklyInspectionlist";
import WeeklyInspection from "../screens/WeeklyInspection/WeeklyInspection";
import WorkorderCustomers from "../screens/WorkOrderRequest/WorkorderCustomers/WorkorderCustomers";
import Customers from "../screens/Customers/Customers/Customers";
import JobDetails from "../screens/Customers/JobDetails/JobDetails";
import WorkOrderDetail from "../screens/WorkOrderRequest/WorkOrders/WorkOrderDetail";
import EditCategory from "../screens/WorkOrderRequest/EditJobDetails/EditCategory";
import EditJobDetails from "../screens/WorkOrderRequest/EditJobDetails/Jobdetails";
import ShiftDetails from "../screens/WorkOrderRequest/EditJobDetails/ShiftDetails";
import CreateInstructionsChecklist from "../screens/Instructions/CreateInstructionsChecklist/CreateInstructionsChecklist";
import CTSLocations from "../screens/CleanerTaskSummary/Locations/CTSLocations";
import CreateNewCustomer from "../screens/Customers/CreateNewCustomer/CreateNewCustomer";
import CustomerDetail from "../screens/Customers/CustomerDetail/CustomerDetail";
import Settings from "../screens/Setting/Settings/Settings";
import ChangeLanguage from "../screens/Setting/ChangeLanguage/ChangeLanguage";
import ChangePassword from "../screens/Setting/ChangePassword/ChangePassword";
import Notification from "../screens/Setting/Notification/Notification";
import CleanerTaskSummary from "../screens/CleanerTaskSummary/CTS/CleanerTaskSummary";
import CleanersCTS from "../screens/CleanerTaskSummary/CleanersCTS/CleanersCTS";
import Cleaners from "../screens/Cleaners/Cleaners";
import NewCleaners from "../screens/Cleaners/NewCleaners/NewCleaners";
import CleanerDetails from "../screens/Cleaners/CleanerDetails/CleanerDetails";
import Schedule from "../screens/Schedule/schedule/Schedule";
import TimeSheet from "../screens/Schedule/timeSheet/TimeSheet";
import TimeSheetList from "../screens/Schedule/timeSheetList/TimeSheetList";
import Calendar from "../screens/Schedule/calendar/Calendar";
import CalendarSchedule from "../screens/Schedule/calendar/Calendar";
import CalendarSchedules from "../screens/Schedule/calendarSchedule/CalendarSchedules";
import PastScheduleDetails from "../screens/Schedule/pastSchedule/pastScheduleTabs/PastScheduleTabs";
import ProblemReport from "../screens/ProblemReport/ProblemReport";
import Map from "../screens/Map/Map";
import CleanerHome from "../screens/CleanerHome/CleanerHome";
import CleanerJobs from "../screens/CleanerJobs/CleanerJobs";
import ActiveJob from "../screens/CleanerJobs/ActiveJob/ActiveJob";
import CleanerChecklist from "../screens/CleanerChecklist/CleanerChecklist";
import CustomerHome from "../screens/CustomerHome/CustomerHome";
import { roles } from "../config/roles";
import CustomerCleaner from "../screens/Cleaners/CustomerCleaner/CustomerCleaner";
import WORform from "../screens/WORform/WORform";
import Stores from "../screens/Stores/Stores";
import StoreInventory from "../screens/StoreInventory/StoreInventory";
import EditCleaners from "../screens/Cleaners/EditCleaner/EditCleaner";
import Companies from "../screens/Companies/Companies";
import CreateCompany from "../screens/Companies/CreateCompany/CreateCompany";
import EditCompany from "../screens/Companies/EditCompany/EditCompany";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<HomeLayout />}>
        <Route path="/" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgetPassword" element={<ForgetPassword />} />
      </Route>


      <Route element={<ProtectedLayout />}>


        {/*=================================================== cleaner Screens ======================================= */}

        <Route element={<CleanerLayout />}>

          <Route path={"/cleanerHome"} element={<CleanerHome />} />
          <Route path={"/jobs"} element={<CleanerJobs />} />
          <Route path={"/checklist"} element={<CleanerChecklist />} />
          <Route path={"/jobs/ActiveJobs"} element={<ActiveJob />} />
          <Route path={"/jobs/PastJobs"} element={<ActiveJob />} />

        </Route>

        {/*=================================================== contractor Screens ======================================= */}

        <Route element={<ContractorLayout />}>

          {/*====================== home Screens ======================= */}

          <Route path={"/contractorHome"} element={<ContractorHome />} />
          <Route path={"/contractorHome/Checklist"} element={<CheckList />} />
          <Route path={"/contractorHome/Checklist/ChecklistReport"} element={<ChecklistReport />} />
          <Route path={"/contractorHome/Checklist/CreateChecklist"} element={<CreateCheckList />} />
          <Route path={"/contractorHome/WeeklyInspection"} element={<WeeklyInspectionlist />} />
          <Route path={"/contractorHome/WeeklyInspection/Details"} element={<WeeklyInspection />} />
          <Route path={"/contractorHome/Customers"} element={<Customers />} />
          <Route path={"/contractorHome/Customers/JobDetails"} element={<JobDetails />} />
          <Route path={"/contractorHome/CreateNewCustomer"} element={<CreateNewCustomer />} />
          <Route path={"/contractorHome/Customer"} element={<CustomerDetail />} />
          <Route path={"/contractorHome/location"} element={<Location />} />
          <Route path={"/contractorHome/Location/LocationDetails"} element={<LocationDetail />} />
          <Route
            path={"/contractorHome/Location/CreateChecklist"}
            element={<CreateInstructionsChecklist />}
          />

          {/*====================== schedule Screens ======================= */}
          <Route path={"/schedule/TimeSheet"} element={<TimeSheet />} />
          <Route path={"/schedule/TimeSheetList"} element={<TimeSheetList />} />

          {/*====================== companies Screens ======================= */}
          <Route path={"/company"} element={<Companies />} />
          <Route path={"/company/CreateNewCompany"} element={<CreateCompany />} />
          <Route path={"/company/EditCompany"} element={<EditCompany />} />

          {/*====================== Cleaners Screens ======================= */}

          <Route path={"/Cleaners"} element={<Cleaners />} />
          <Route path={"/Cleaners/NewCleaners"} element={<NewCleaners />} />
          <Route path={"/Cleaners/EditCleaner"} element={<EditCleaners />} />
          <Route path={"/Cleaners/NewCleaners/Profile"} element={<CleanerDetails />} />

          {/*====================== WorkOrderRequest Screens ======================= */}

          <Route path={"/WorkOrderRequest/Customers"} element={<WorkorderCustomers />} />
          <Route path={"/WorkOrderRequest/EditJobDetails"} element={<EditCategory />} />
          <Route path={"/WorkOrderRequest/JobDetails"} element={<EditJobDetails />} />
          <Route path={"/WorkOrderRequest/CreateChecklist"} element={<ShiftDetails />} />

          {/*====================== subscription Screens ======================= */}

          <Route path={"/subscription"} element={<Subscription />} />
          <Route path={"/subscription/AddCard"} element={<AddCard />} />
          <Route
            path={"/subscription/AddCard/Payments"}
            element={<Payments />}
          />

          {/*====================== categories Screens ======================= */}

          <Route path={"/categories"} element={<Categories />} />
          <Route
            path={"/categories/categoryDetail"}
            element={<CategoriesDetail />}
          />

          {/*====================== problem Report Screens ======================= */}

          <Route path={"/problemReport"} element={<ProblemReport />} />

        </Route>

        {/*=================================================== customer Screens ======================================= */}

        <Route element={<CustomerLayout />}>

          <Route path={"/customerHome"} element={<CustomerHome />} />
          <Route path={"/customerCleaner"} element={<CustomerCleaner />} />
          <Route path={"/WorkOrderRequestForm"} element={<WORform />} />
          <Route path={"/WorkOrderRequestForm/Stores"} element={<Stores />} />
          <Route path={"/WorkOrderRequestForm/Stores/Inventory"} element={<StoreInventory />} />

        </Route>



        {/*=================================================== common Screens ========================================================== */}


        <Route element={<CommonLayout roles={[roles.contractor, roles.customer]} />}>

          {/*====================== cleanerTaskSummary Screens ======================= */}

          <Route path={"/cleanerTaskSummary/Cleaners"} element={<CleanersCTS />} />
          <Route path={"/cleanerTaskSummary/Locations"} element={<CTSLocations />} />
          <Route path={"/cleanerTaskSummary/CleanerTaskSummary"} element={<CleanerTaskSummary />} />
          <Route path={"/cleanerTaskSummary/CleanerTaskSummary/Map"} element={<Map />} />

          {/*====================== schedule Screens ======================= */}

          <Route path={"/schedule"} element={<Schedule />} />
          <Route path={"/schedule/PastSchedule/Details"} element={<PastScheduleDetails />} />

          {/*====================== WorkOrderRequest Screens ======================= */}

          <Route path={"/WorkOrderRequest/WorkOrderList"} element={<WorkOrders />} />
          <Route path={"/WorkOrderRequest/WorkOrderDetail"} element={<WorkOrderDetail />} />


        </Route>

        {/*====================== ts pp contact settings Screens ======================= */}

        <Route path={"/termsAndServices"} element={<TermsAndConditions />} />
        <Route path={"/privacyPolicy"} element={<PrivacyPolicy />} />
        <Route path={"/Settings"} element={<Settings />} />
        <Route path={"/Settings/Language"} element={<ChangeLanguage />} />
        <Route path={"/Settings/ChangePassword"} element={<ChangePassword />} />
        <Route path={"/Notifications"} element={<Notification />} />
        <Route path={"/contactUs"} element={<ContactUs />} />


        {/*====================== Cleaners Screens ======================= */}

        <Route path={"/Cleaners/ActiveCleaners/Profile"} element={<CleanerDetails />} />

        {/*====================== chat Screens ======================= */}

        <Route path={"/chat/Inbox"} element={<Inbox />} />
        <Route path={"/chat/Chat"} element={<Chat />} />

        {/*====================== profile Screens ======================= */}

        <Route path={"/editprofile"} element={<EditProfile />} />
        <Route path={"/profile"} element={<Profile />} />

        {/*====================== schedule Screens ======================= */}

        <Route path={"/schedule/Calendar"} element={<Calendar />} />
        <Route path={"/schedule/Calendar/Schedules"} element={<CalendarSchedules />} />


      </Route>
      <Route
        path="*"
        element={
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
          // extra={<Button type="primary">Back Home</Button>}
          />
        }
      />
    </>
  )
);
